import React, { useEffect, useState } from "react";
import {
  faClipboardQuestion,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Contact_details_card from "../../common_components/contact_details_card/Contact_details_card";
import { luxuryDelivery } from "../../../utils/luxuryapis/Home/Homeapi";
import parse from "html-react-parser";
import { formatDate } from "../../../utils/apis/common/Common";

function Delivaries() {
  const [data, setData] = useState({});

  const getData = async () => {
    const res = await luxuryDelivery();
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <section className="Legal_notice">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-8">
              <div className="content_box_holder">
                <div className="heading_strip_holder">
                  <h1>DELIVERY AND SUPPORT INFORMATION</h1>
                </div>
              </div>

              <div className="content_box_holder">
                <div className="content_holder">
                  <div className="text_holder">
                    <p>Last updated on Wednesday, {formatDate(data?.createdAt)}</p>
                    <h4>{data?.name}</h4>
                    <hr />

                    {typeof data?.description === "string"
                      ? parse(data?.description)
                      : ""}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <Contact_details_card />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Delivaries;
